import axios from "axios";

export default class SegmentService {
    get(){
        return new Promise(async (resolve, reject) => {
            try {
                let response = await axios.get("api/segment/");
                resolve(response.data);
            } catch(ex){
                reject(ex);
            }
        })
    }
}